import * as React from "react";
import { Props } from "../types";
import { ImageSlider } from "./ImageSlider";
import * as objectHash from "object-hash";

export const ImageModal = (props: Props.ImageModal) => {
    const modalRef = React.useRef<HTMLDivElement>(null);

    const handleOutsideClick = e => {
        if (props.show && modalRef.current && !modalRef.current.contains(e.target)) {
            props.onClose();
        }
    };
    React.useEffect(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };

    }, []);

    React.useEffect(() => {
        if (props.show) {
            document.body.classList.add('scroll-block');
        } else {
            document.body.classList.remove('scroll-block');
        }
    }, [props.show])

    return (<div className={props.show ? 'c-modal show' : 'c-modal'} ref={modalRef}>
            <div className={'c-modal__backdrop'} onClick={() => props.onClose()}>
                <div className="c-modal__container" onClick={(e) => e.stopPropagation()}>
                    <div className={'c-modal__content'}>
                        <button aria-label="Close" className="c-modal__content__close"
                                onClick={() => props.onClose()}></button>
                        <ImageSlider key={`slider_${objectHash(props)}`} imageIndex={props.imageIndex}
                                     galleryImages={props.galleryImages}/>
                    </div>
                </div>
            </div>
        </div>);
}
